module.exports = __webpack_public_path__ + "img/trophy_2.png";